import { render } from "./PurchaseTableDirector1.vue?vue&type=template&id=9b7ce7ee"
import script from "./PurchaseTableDirector1.vue?vue&type=script&lang=js"
export * from "./PurchaseTableDirector1.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__